import React from 'react';
import { firstErrorMessage } from '@/utils/errors';
import Error from '@/components/errors/Error';
import Selectors from '../hooks/selectors';

const RequestConfirmationError = ({ category, code }) => {
  const { saveErrors, readErrors, workflowError } = Selectors.useRequestConfirmationError({ category, code });
  const requestError = firstErrorMessage(saveErrors) || firstErrorMessage(readErrors) || workflowError;

  if (!requestError) {
    return null;
  }

  return (
    <Error error={requestError} className="aridhia-request-confirmation" />
  );
};

export default RequestConfirmationError;
